import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  tableCellClasses,
  Paper,
  CircularProgress,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import {
  //  CheckIcon,
  FontFamily,
  // PendingIcon,
  SearchIcon,
} from "assets";
import Colors from "assets/Style/Colors";
import { PrimaryButton } from "components/Buttons";
import SelectField from "components/Select";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import DropdownMenu from "components/DropDown";
import Pagination from "components/Pagination";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import InputField from "components/Input";
import SupplierServices from "services/Supplier";
import { CommaSeparator, Debounce } from "utils";
import moment from "moment";
import ConfirmationDialog from "components/Dialog/ConfirmationDialog";
import { formatPermissionData } from "utils";
import { addPermission } from "redux/slices/navigationDataSlice";
import { useDispatch } from "react-redux";
// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function BillAndApproval() {
  const mockSupplierData = [
    {
      id: 1,
      supplierCode: "SUP123",
      supplierName: "Supplier A",
      creditLimit: 50000,
      balanceDue: 12000,
      overdue: 3000,
      status: "Active",
      invoices: 10,
    },
    {
      id: 2,
      supplierCode: "SUP124",
      supplierName: "Supplier B",
      creditLimit: 70000,
      balanceDue: 25000,
      overdue: 5000,
      status: "In Active",
      invoices: 15,
    },
  ];
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();
  const [loader, setLoader] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [bills, setBills] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(null);
  const [supplierData, setSupplierData] = useState(mockSupplierData);
  const [openPopup, setOpenPopup] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);

  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [billId, setBillId] = useState();
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [permissions, setPermissions] = useState({});
  const dispatch = useDispatch();
  const [confirmationApprovalDialog, setConfirmationApprovalDialog] =
    useState(false);

  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null);
  };
  const navigate = useNavigate();

  const tableHead = [
    "Bill no.",
    "Bill Date",
    "Supplier Name",
    "Amount ($)",
    "VAT ($)",
    "Total Due ($)",
    "COA List",
    "Remarks",
    // "Past Due Days",
    "Pmt Status",
    "Approval",
    "Created by",
    "Approved by",
    "Action",
  ];

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const sanitizeFilters = (obj) => {
    const next = { ...(obj || {}) };
    Object.keys(next).forEach((key) => {
      const value = next[key];
      if (value === undefined || value === null || value === "") {
        delete next[key];
      }
    });
    return next;
  };

  const getBill = async (page, limit, filter) => {
    setLoader(true);

    try {
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = sanitizeFilters({ ...filters, ...filter });
      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);
      let params = {
        page: Page,
        limit: Limit,
        // status: true,
      };
      params = { ...params, ...Filter };

      const data = await SupplierServices.getBill(params);
      const rows = data?.data?.bills?.rows ?? [];
      const serverCount = data?.data?.bills?.count;
      setBills(rows);
      setTotalCount(serverCount > 0 ? serverCount : rows.length);
      setPermissions(formatPermissionData(data?.data?.permissions));
      data?.data?.permissions?.forEach((e) => {
        if (e?.route && e?.identifier && e?.permitted) {
          dispatch(addPermission(e?.route));
        }
      });
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const handleFilter = (data) => {
    Debounce(() => getBill(1, "", data));
  };

  const handleApprovalStatusSelect = (value) => {
    setSelectedSupplier(value);

    if (!value?.id || value?.id === "all") {
      handleFilter({ approved: null });
      return;
    }

    if (value?.id === "approved") {
      handleFilter({ approved: "true" });
      return;
    }

    if (value?.id === "pending") {
      handleFilter({ approved: "false" });
      return;
    }
  };

  const handlePaymentStatusSelect = (value) => {
    setSelectedPaymentStatus(value);

    if (!value?.id || value?.id === "all") {
      handleFilter({ status: null });
      return;
    }

    if (value?.id === "paid") {
      handleFilter({ status: "true" });
      return;
    }

    if (value?.id === "unpaid") {
      handleFilter({ status: "false" });
      return;
    }
  };

  useEffect(() => {
    getBill();
  }, []);

  const calculateTotalAmount = (billAccounts) => {
    return billAccounts.reduce(
      (total, account) => total + parseFloat(account?.bill_amount),
      0,
    );
  };

  const calculateVatAmount = (billAccounts) => {
    return billAccounts.reduce(
      (total, account) => total + parseFloat(account?.vat_amount),
      0,
    );
  };

  const calculateGrandTotalAmount = (billAccounts) => {
    return billAccounts.reduce(
      (total, account) => total + parseFloat(account?.total_amount),
      0,
    );
  };

  const deleteBill = async () => {
    try {
      let params = { bill_id: billId };
      const { message } = await SupplierServices.deleteBill(params);
      SuccessToaster(message);
      setConfirmationDialog(false);
      getBill();
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const approveBill = async () => {
    try {
      let params = { bill_id: billId };
      const { message } = await SupplierServices.approveBill(params);
      SuccessToaster(message);
      setConfirmationApprovalDialog(false);
      getBill();
    } catch (error) {
      ErrorToaster(error);
    }
  };

  return (
    <Box sx={{ m: 4, mb: 8 }}>
      <ConfirmationDialog
        open={confirmationDialog}
        onClose={() => setConfirmationDialog(false)}
        message={"Are you sure you want to delete this?"}
        action={() => deleteBill()}
      />
      <ConfirmationDialog
        open={confirmationApprovalDialog}
        onClose={() => setConfirmationApprovalDialog(false)}
        message={"Are you sure you want to approve this?"}
        action={() => approveBill()}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
          mt: 4,
          mr: 4,
        }}
      >
        <Typography
          sx={{
            color: "#094526",
            fontFamily: "Helvetica",
            fontSize: "32px",
            fontStyle: "Bold",
            fontWeight: 700,
          }}
        >
          Bills & Approvals
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box>
            <PrimaryButton
              title={"Book Bill"}
              onClick={() => window.open("/book-bill")}
            />
          </Box>
        </Box>
      </Box>

      {/* Form Section */}
      <Box
      // sx={{
      //   boxShadow: "0px 4px 4px 0px #00000040",
      //   p: 3,
      //   borderRadius: "12px",
      // }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <InputField
              size={"small"}
              inputStyle={{ backgroundColor: "#f5f5f5" }}
              label={"Search"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              placeholder={"Search"}
              register={register("search", {
                onChange: (e) => handleFilter({ search: e.target.value }),
              })}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <SelectField
              label={"Approval Status"}
              options={[
                { id: "all", name: "All" },
                { id: "pending", name: "Pending" },
                { id: "approved", name: "Approved" },
              ]}
              selected={selectedSupplier}
              onSelect={handleApprovalStatusSelect}
              register={register("approvalStatus")}
            />
          </Grid>

          {/* <Grid item xs={12} sm={3.5}>
            <SelectField
              label={"Select Vendor"}
              options={vendors}
              selected={selectedVendor}
              onSelect={(value) => {
                setSelectedVendor(value);
              }}
              register={register("vendor", {
                required: "Please select supplier status.",
              })}
            />
          </Grid> */}

          <Grid item xs={12} sm={3}>
            <SelectField
              label={"Payment Status"}
              options={[
                { id: "all", name: "All" },
                { id: "paid", name: "Paid" },
                { id: "unpaid", name: "Un-Paid" },
              ]}
              selected={selectedPaymentStatus}
              onSelect={handlePaymentStatusSelect}
              register={register("paymentStatus")}
            />
          </Grid>
        </Grid>
      </Box>

      {/* ========== Table ========== */}
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0px 8px 18px 0px #9B9B9B1A",
          borderRadius: 2,
          maxHeight: "calc(100vh - 330px)",
          mt: 5,
        }}
        className="table-box"
      >
        <Table stickyHeader sx={{ minWidth: 500 }}>
          <TableHead>
            <TableRow>
              {tableHead.map((item, index) => (
                <Cell className="pdf-table" key={index}>
                  {item}
                </Cell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!loader ? (
              bills?.length > 0 ? (
                <Fragment>
                  {bills.map((item, index) => {
                    return (
                      <Row
                        key={index}
                        sx={{ bgcolor: index % 2 !== 0 && "#EEFBEE" }}
                      >
                        <Cell className="pdf-table">
                          {item?.bill_no ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.bill_date ? moment(item.bill_date).format("DD-MM-YYYY") : "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.suppliers?.company_name ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {
                            CommaSeparator(
                              (Number(calculateTotalAmount(item?.bill_accounts)) || 0).toFixed(2)
                            )
                          }
                        </Cell>
                        <Cell className="pdf-table">
                          {calculateVatAmount(item?.bill_accounts)}
                        </Cell>
                        <Cell className="pdf-table">
                          { CommaSeparator(
                          (Number(calculateGrandTotalAmount(item?.bill_accounts)) || 0).toFixed(2)
                          )}
                        </Cell>
                        <Cell className="pdf-table">
                          {(() => {
                            if (!item?.bill_accounts?.length) return "-";
                            const names = [...new Set(item.bill_accounts.map((a) => {
                              const seg = a?.full_path?.split("\u2192");
                              return seg ? seg[seg.length - 1]?.trim() : (a?.account_id ?? "-");
                            }))];
                            if (names.length <= 1) return names[0] || "-";
                            return (
                              <Tooltip title={names.slice(1).join(", ")} arrow>
                                <span style={{ cursor: "default" }}>
                                  {names[0]}{" "}
                                  <span style={{ color: Colors.primary, fontWeight: 600 }}>+{names.length - 1}</span>
                                </span>
                              </Tooltip>
                            );
                          })()}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.remarks || "-"}
                        </Cell>
                        {/* <Cell className="pdf-table">
                          {item?.suppliers?.credit_days ?? "-"}
                        </Cell> */}
                        <Cell className="pdf-table">
                          {item?.pmt_status?.toString().toLowerCase() === "paid" ? "Paid" : "Unpaid"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.approved ? "Approved" : "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.created_by?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.approved_by?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {
                            <DropdownMenu
                              item={item}
                              permissions={permissions}
                              navigate={navigate}
                              isOpen={activeMenu === item?.id}
                              onToggle={(isOpen) =>
                                handleMenuToggle(item?.id, isOpen)
                              }
                              id={item?.id}
                              BillApprove={
                                !item?.approved
                                  ? () => {
                                    setConfirmationApprovalDialog(true);
                                    setBillId(item?.id);
                                  }
                                  : null
                              }
                              BillView={() => {
                                window.open(
                                  `/supplier-bill-approval-receipt/${item?.id}`,
                                );
                              }}
                              BillEdit={() => {
                                window.open(`/update-bill/${item?.id}`);
                              }}
                              BillDelete={() => {
                                setConfirmationDialog(true);
                                setBillId(item?.id);
                              }}
                            />
                          }
                        </Cell>
                      </Row>
                    );
                  })}
                </Fragment>
              ) : (
                <Row>
                  <Cell colSpan={11} align="center" sx={{ fontWeight: 600 }}>
                    No Data Found
                  </Cell>
                </Row>
              )
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center" sx={{ border: 0, py: 4 }}>
                  <CircularProgress size={40} sx={{ color: Colors.primary }} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {bills?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          pageSize={pageLimit}
          onPageSizeChange={(size) => getBill(1, parseInt(size.target.value))}
          tableCount={bills?.length}
          totalCount={totalCount}
          onPageChange={(page) => getBill(page, "")}
        />
      )}
    </Box>
  );
}

export default BillAndApproval;
